module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"placeholder":"Nach Firmengruppe suchen"},"en":{"placeholder":"Search for a Firmengruppe"}}')
  delete Component.options._Ctor
}
